<template>
  <button class="text-button" type="button" tabindex="0" @click.stop="$emit('click')">
    <div>{{ label }}</div>
  </button>
</template>

<script>
export default {
  name: 'TextButton',
  props: {
    label: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/datepicker.scss";

.text-button {
  position: relative;
  font-family: $font-family-grotesk;
  color: $darkBlack;
  font-size: 12px;
  font-weight: 500;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  text-align: left;
  display: block;
  padding: 0;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.07em;

  @include dp-mobile-up(){
    &:hover{
    }
  }
  @include dp-mobile-down-sm(){
    font-size: 16px;
  }
}
</style>
